import { apiClient } from './client';
import type { MetricsHistoryResponse, OverviewSummary } from '../types';

export const overviewApi = {
  async getSummary(): Promise<OverviewSummary> {
    const { data } = await apiClient.get<OverviewSummary>('/overview/summary');
    return data;
  },
  async getHistory(hours = 24 * 7): Promise<MetricsHistoryResponse> {
    const { data } = await apiClient.get<MetricsHistoryResponse>('/overview/history', { params: { hours } });
    return data;
  },
};
